import { render, staticRenderFns } from "./FormSponsorTexts.vue?vue&type=template&id=058e6834&"
import script from "./FormSponsorTexts.vue?vue&type=script&lang=js&"
export * from "./FormSponsorTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports